// Copyright (c) 2019 Deere & Company

import './index.scss';
import AuthenticatedPage from '../app/common/components/authenticated-page';
import Preferences from './components/preference';
import React from 'react';

const PreferencePage = ( ) => (
    <AuthenticatedPage className="pref-page">
        <Preferences />
    </AuthenticatedPage>
);
export default PreferencePage;
